var Base = require('_js/base');

function ParentAccordionList() {}

ParentAccordionList.prototype = new Base();

ParentAccordionList.prototype.init = function() {
  var self = this;
  var $toggler = $('[data-parent-accordion-id]');
  if ($toggler.length > 0) {
    //toggle accordion
    $toggler.on('click', function(e) {
      self.handleAccordionToggle(e, this, 'parent-accordion-id');
    });
  }
};

ParentAccordionList.prototype.start = function(
  dataId,
  container,
  clickCallback
) {
  var self = this;
  var $container = $(container);
  var $toggler = $('[data-' + dataId + ']');
  if (typeof clickCallback !== 'function') {
    clickCallback = function() {};
  }

  if ($container) {
    $container.on('click', '[data-' + dataId + ']', function(e) {
      self.handleAccordionToggle(e, this, dataId);
      clickCallback();
    });
  } else if ($toggler.length > 0) {
    //toggle accordion
    $toggler.on('click', function(e) {
      self.handleAccordionToggle(e, this, dataId);
      clickCallback();
    });
  }
};

ParentAccordionList.prototype.handleAccordionToggle = function(
  e,
  elem,
  dataId
) {
  e.preventDefault();

  var $this = $(elem);
  var accordionList = $this
    .parents('.parent-accordion-list')
    .find('.parent-accordion-list-item');
  var id = $this.data(dataId);

  $this.toggleClass('is-selected');

  $.each(accordionList, function() {
    var content = $(this).find('.parent-accordion-list-content'),
      target = content.data('parent-accordion-target');

    if (target === id) {
      content.toggleClass('is-open');
      content.slideToggle(600, 'easeOutQuart');
    }
  });
};
module.exports = ParentAccordionList;
